export const APP_ROOT = '/';
export const AUTHORISATIONS = '/authorisations/';
export const AUTHORISATIONS_OVA = '/authorisations-new/';
export const CALLBACK = '/callback';
export const EDUCATION_PREPARATION = '/education-preparation/';
export const ERROR = '/error';
export const LOGIN = '/login';
export const LOGOUT = '/logout';
export const COURSE_REGISTRATION = '/course-registration/';
export const STUDENTS = '/students/';
export const UNAUTHORISED = '/unauthorised';
export const USER_BLOCKED = '/user-blocked';
